import useAdditionalModules from "../../../http/public/useAdditionalModules";
import Option from "../../../Models/forms/Option";

export default (): Option[] =>
  useAdditionalModules().map((module) => ({
    value: module.name,
    label: module.name,
  }));
